const state = {
    apiUrl: `https://${process.env.VUE_APP_API_URL}`,
}

export default state